/**
 * 查看详情
 * 2017-12-27
 * by 于再洋
 */
"use strict";
angular.module("edithotModule", []).
controller("edithotCtrl", ["$scope", '$modalInstance', 'trsHttpService', 'trsconfirm', "$document","$timeout", "newTopicRuleService", function($scope, $modalInstance, trsHttpService, trsconfirm, $document,$timeout, newTopicRuleService) {
	initStatus();
    initData();
    /**
     * [initStatus description] 初始化状态
     * @return {[type]} [description]
     */
    function initStatus() {
        $scope.status = {
            pageNo:0,
            pageSize:10,
            saveright:false,//保存提示
            saveerr:false,//错误提示
            prompt:false,//提示
            wbSelect:true,//微博单选框
            wbRange:'1',//微博范围
            wzSelect:true,//文章单选框
            wzRange:'2',//文章范围
            hasId:false,
            adcontinue: true,

        };
        $scope.data = {
            id:"",//规则id
            name:"",//规则名称
            content:"",//规则详情
            range:"",//规则范围
        };
        $scope.promptMes ="";
    }
    /**
     * [initData description] 初始化数据
     * @return {[type]} [description]
     */
    function initData() {
    }
    /**
     * [ruletest description] 保存前验证
     * @return {[type]} [description]
     */
    $scope.ruletest = function() {
        if($scope.data.content == ""){
            $scope.status.prompt = true;
            $scope.promptMes = "内容不能为空";
            $timeout(function(){
                $scope.status.prompt = false;
            },2000);
            return;
        } else {
            if($scope.data.content.length >= 5000){
                $scope.data.content = $scope.data.content.substr(0,5000);
            }
            if($scope.data.name == ""){
                $scope.status.prompt = true;
                $scope.promptMes = "规则名称不能为空";
                $timeout(function(){
                    $scope.status.prompt = false;
                },2000);
                return;
            } else {
                if($scope.data.name.length > 50){
                    $scope.data.name = $scope.data.name.substr(0,50);
                }
                //判断规则名称是否存在
                $scope.status.adcontinue = true;
                var params = {
                     "typeid": 'screen',
                     "serviceid": 'zjsentimentrulemgr',
                     "modelid": 'getrulelist',
                     "type":'1',
                     "search_word":'',
                     "page_no":$scope.status.pageNo,
                     "page_size":$scope.status.pageSize,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
                    if(data.content){
                        for (var i = 0; i < data.content.length; i ++) {
                            if(data.content[i].ruleName == $scope.data.name){
                                $scope.status.prompt = true;
                                $scope.promptMes = "已存在此名称的记录";
                                $timeout(function(){
                                    $scope.status.prompt = false;
                                },2000);
                                $scope.status.adcontinue = false;
                                return;
                            }
                        }
                    }
                    
                    if($scope.status.adcontinue == true){
                    if($scope.status.wbSelect == false && $scope.status.wzSelect == false){
                        $scope.status.prompt = true;
                        $scope.promptMes = "规则范围不能为空";
                        $timeout(function(){
                            $scope.status.prompt = false;
                        },2000);
                        return;
                    }else {
                        if($scope.status.wbSelect == true && $scope.status.wzSelect == true){
                            $scope.data.range ='0';
                        }else{
                            if($scope.status.wbSelect == true){
                                $scope.data.range ='1';
                            }else if($scope.status.wzSelect == true){
                                $scope.data.range ='2';
                            }
                        } 
                        rulesave();
                    }
                }
                });
                
            }
        }
    };
    /**
     * [rulesave description] 保存
     * @return {[type]} [description]
     */
    function rulesave() {
        var params = {
             "typeid": 'screen',
             "serviceid": 'zjsentimentrulemgr',
             "modelid": 'saverule',
             "type":'1',
             "name":$scope.data.name,
             "content":$scope.data.content,
             "range":$scope.data.range,
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
            $scope.status.saveright = true;
            $scope.promptMes = "添加成功！";
            $timeout(function(){
                $scope.status.saveright = false;
                $modalInstance.close(true);
            },2000);
        });
    };
    /**
     * [cancel description] 取消
     * @return {[type]} [description]
     */
    $scope.cancel = function() {
        //如果标题或者内容有值调用窗口询问是否放弃
        if($scope.data.name || $scope.data.content){
            newTopicRuleService.giveup().then( function(data){
                if(data == true){
                    $modalInstance.dismiss();
                }
            });
        }else {
            $modalInstance.dismiss();
        }
    };

}]);